import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";
import Logo from "../components/Logo";

const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div
        className="hidden lg:block relative"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1621993646147-8cde7b9cc031?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBjYW1lcmElMjBvbiUyMHNldHxlbnwwfHx8fDE3Nzc1MTEyODN8MA&ixlib=rb-4.1.0&q=85')`,
          backgroundSize: "cover", backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/40 to-black/80" />
        <div className="absolute top-12 left-12">
          <Logo size={44} linkTo="/" />
        </div>
        <div className="absolute bottom-12 left-12 right-12">
          <div className="label-caps mb-4">Studio Access</div>
          <h2 className="font-editorial text-5xl leading-none tracking-tight">
            Back to the <em>cutting room</em>.
          </h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-12">
            <Logo size={44} linkTo="/" />
          </div>
          <Link to="/" className="label-caps mb-12 inline-block hidden lg:inline-block" data-testid="login-back-home">← Back to intake</Link>
          <h1 className="font-editorial text-5xl mb-2 tracking-tight">Admin sign in</h1>
          <p className="text-white/50 mb-10 text-sm">Authorized studio staff only.</p>
          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <label className="label-caps mb-2 block">Email</label>
              <input data-testid="login-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="input-editorial" />
            </div>
            <div>
              <label className="label-caps mb-2 block">Password</label>
              <input data-testid="login-password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} className="input-editorial" />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit" className="btn-primary w-full">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
